import * as apiPost from 'api/translation/PostTranslationV1';

export * as Translation from './Translation';

export type Type<T> = {
	[key: string]: T;
};

export function create() {
	return {};
}

export function change<T>(obj: Type<T>, key: string, value: T) {
	if (!value) {
		const output = {
			...obj,
		};
		delete output[key];
		return output;
	}
	return {
		...obj,
		[key]: value,
	};
}

export async function getTranslationFromApi(request: apiPost.Request): Promise<string> {
	const response = await apiPost.callApi(request);
	const responseData = response.toNullable();
	if (!responseData) return '';
	return responseData;
}

export function getFirstTranslation(
	obj: Type<string>,
	cultureCode: string,
	fallback?: string
): string {
	const output = obj[cultureCode];
	if (output) return output;
	for (const value of Object.values(obj)) {
		if (value) return value;
	}
	return fallback ?? '';
}

export function addCopyToEveryExistingKey(obj: Type<string>): Type<string> {
	const output: Type<string> = {};
	for (const [key, value] of Object.entries(obj)) {
		if (value === '') continue;
		output[key] = value + ' - Copy';
	}
	return output;
}
